<template>
  <div>
    <div class="content">
      <van-form @submit="submitJsy" @failed="onFailed">
        <!-- 上传卸货磅单图片 -->
        <van-field
          name="xhbdUrlList"
          label="上传卸货磅单"
          required
          :rules="[{ required: true, message: '请上传卸货磅单' }]"
        >
          <template #input>
            <van-uploader
              v-model="xhbdUrlList"
              :max-size="10240 * 1024"
              :max-count="1"
              @oversize="onOversize"
              :before-read="beforeRead"
              :after-read="afterReadFile"
              :before-delete="deleteUploadImg"
            ></van-uploader>
          </template>
        </van-field>
        <!-- 磅单数量 -->
        <van-field
          v-model="inbdsl"
          name="inbdsl"
          @blur="handleInput($event, 'inbdsl')"
          label="磅单数量"
          type="number"
          placeholder="请输入磅单数量"
          required
          :rules="[{ required: true, message: '请输入磅单数量' }]"
        ></van-field>
        <!-- 净重 -->
        <van-field
          v-if="[1, 2].includes(isSpecified)"
          v-model="bdjingzhong"
          name="bdjingzhong"
          label="净重"
          @blur="handleInput($event, 'bdjingzhong')"
          placeholder="请填写净重"
        ></van-field>
        <!-- 车号 -->
        <van-field
          v-if="[1, 2].includes(isSpecified)"
          v-model="bdch"
          name="bdch"
          label="车号"
          placeholder="上传磅单识别车号"
          :readonly="true"
        ></van-field>
        <van-notice-bar
          v-if="[1, 2].includes(isSpecified) && bdch !== '' && !isChetouhaoMatch"
          :scrollable="false"
          left-icon="info-o"
          text="车头号识别结果和订单绑定车头号不相符。"
        />
        <!-- 品名 -->
        <van-field
          v-if="[1, 2].includes(isSpecified)"
          v-model="bdpinming"
          name="bdpinming"
          label="品名"
          placeholder="请输入品名"
        ></van-field>
        <!-- 卸货单号 -->
        <!-- 卸货单号 -->
        <div style="margin: 1rem">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            class="addBtn"
            @loading="loadingBtn"
          >
            保存
          </van-button>
        </div>
      </van-form>
    </div>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import api from '@/fetch/api';
import { Dialog, Toast } from 'vant';
import Compressor from 'compressorjs';
import Tabbar from '../Public/tabbarTpl.vue';
export default {
  components: {
    Tabbar,
  },
  data() {
    return {
      id: '',
      uploadLoading: false,
      uploadDisabled: false,
      loadingBtn: false,
      order_chetouhao: '', // 当前账号下的车头号

      // 上传列表
      xhbdUrlList: [],
      // 图片完整路径
      xhbdFullUrl: '',
      // 磅单数量
      inbdsl: null,
      // 净重
      bdjingzhong: null,
      // 车号
      bdch: '',
      // 品名
      bdpinming: '',
      // 磅单是否是指定客户的(1马钢, 2纳斯德, 3其他)
      isSpecified: '',
      isChetouhaoMatch: true, // 车头号是否匹配
    };
  },
  created() {
    document.title = '上传电子运单';
    this.id = this.$route.params.id;
    this.isSpecified = this.$route.params.isSpecified;
    this.order_chetouhao = this.$route.params.chetouhao;
  },
  methods: {
    // 数字输入框保留三位小数
    handleInput(e, val) {
      this[val] = e.target.value.match(/^\d*(\.?\d{0,3})/g)[0];
    },

    // 上传前压缩图片大小
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type,
            });
            resolve(newfile);
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err);
          },
        });
      });
    },

    // 提交
    async submitJsy(values) {
      try {
        // console.log(values);
        // 车号识别不一致/为空/不让改
        const formData = new FormData();
        // 请求入参
        formData.append('yyid', this.id);
        formData.append('inxhbdurl', this.xhbdFullUrl);
        formData.append('inbdsl', values.inbdsl);
        // 当是纳斯德/马钢时需要额外传参
        if ([1, 2].includes(this.isSpecified)) {
          formData.append('bdch', values.bdch);
          formData.append('bdpinming', values.bdpinming);
          formData.append('bdjingzhong', values.bdjingzhong);
        }
        const res = JSON.parse(await api.submitxhbdxx(formData));
        if (res.respCode == '0') {
          Dialog.alert({
            message: '信息保存成功',
          }).then(() => {
            // 返回订单列表页面
            this.$router.push({
              name: 'orderdetail',
              params: {
                id: this.id,
              },
            });
          });
        } else {
          Toast.fail(res.data.message);
        }
      } catch (err) {
        Toast.fail('连接失败，请刷新页面');
      }
    },

    // 处理校验失败
    onFailed(err) {
      console.log(err);
      Toast.fail(err.errors[0].message);
    },

    onOversize(file) {
      console.log(file);
      Toast('文件大小不能超过 10Mb');
    },

    // 上传磅单 & OCR识别
    async afterReadFile(file) {
      try {
        this.$store.commit('set_isLoading', true);
        const formData = new FormData();
        formData.append('yyid', this.id);
        // formData.append('yyid', '2c93f0b183ca22660183caea58f60046');
        formData.append('xhbdpics', file.file);
        const res = JSON.parse(await api.postxhbd(formData));
        // console.log(res);
        if (res.respCode === '0') {
          // console.log(this.xhbdUrlList);
          // this.xhbdFullUrl = this.GLOBAL.weburl + '/' + res.data.xhbdurl;
          this.xhbdFullUrl = res.data.xhbdurl;
          // console.log(this.xhbdFullUrl);
          // 回显OCR识别字段
          this.$nextTick(() => {
            this.bdjingzhong = res.data.bdjingzhong;
            this.bdpinming = res.data.bdpinming;
            this.bdch = res.data.bdch;
            this.isChetouhaoMatch = res.data.bdch === this.chetouhao;
            this.$store.commit('set_isLoading', false);
          });
        } else {
          this.$store.commit('set_isLoading', false);
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(res.data.message);
        }
      } catch (error) {
        this.$store.commit('set_isLoading', false);
        Toast.fail('连接失败，请刷新页面');
      }
    },

    // 删除图片
    deleteUploadImg(file, detail) {
      // 删除图片
      this.xhbdUrlList.splice(detail.index, 1);
      // 重置表单
      this.xhbdFullUrl = '';
      this.bdpinming = '';
      this.bdjingzhong = null;
      this.inbdsl = null;
      this.bdch = '';
      this.isChetouhaoMatch = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin-top: 1rem;
  padding: 0 0.75rem;
  .addBtn {
    background: #316892;
  }
  .upload-box {
    margin: 1rem;
    padding-bottom: 1rem;
    .upload-box__title {
      padding: 1rem 0;
    }
  }
}
.preview-cover {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 4px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
}
.bdextra {
  color: #3c3c3c;
  margin-left: 0.5rem;
}
</style>
